export { default } from './RedirectWithErrorMessage';



// WEBPACK FOOTER //
// ./src/routing/RedirectWithErrorMessage/index.ts